import { render, staticRenderFns } from "./betconstruct.vue?vue&type=template&id=325cf6f7"
import script from "./betconstruct.vue?vue&type=script&lang=js"
export * from "./betconstruct.vue?vue&type=script&lang=js"
import style0 from "./betconstruct.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/betconstruct.vue
// module id = RzUE
// module chunks = 0